import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './BackupHealth.css';

const API = process.env.REACT_APP_API_URL;

function BackupHealth() {
  const [backupData, setBackupData] = useState(null);
  const [isLoading, setIsLoading]   = useState(true);
  const [error, setError]           = useState(null);

  const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

  const fetchBackupHealth = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${API}/admin/security/backup-health`, { headers: getHeaders() });
      setBackupData(res.data);
    } catch (err) {
      console.error('BackupHealth: fetchBackupHealth failed:', err);
      setError(err.response?.status === 403 ? 'Access denied' : 'Failed to load backup health');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBackupHealth();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const formatDate = (ts) => ts ? new Date(ts).toLocaleString() : 'Never';

  const renderOverallBadge = (status) => (
    <span className={`backup-overall-badge backup-overall-badge--${status || 'critical'}`}>
      {(status || 'critical').charAt(0).toUpperCase() + (status || 'critical').slice(1)}
    </span>
  );

  const renderStatusCard = ({ title, lastRunLabel, lastRun, fileSize, status }) => (
    <div className={`backup-status-card backup-status-card--${status || 'critical'}`}>
      <div className="backup-card-title">{title}</div>
      <div className="backup-card-row">
        <span className="backup-card-key">{lastRunLabel}</span>
        <span className="backup-card-value">{formatDate(lastRun)}</span>
      </div>
      {fileSize && (
        <div className="backup-card-row">
          <span className="backup-card-key">File size</span>
          <span className="backup-card-value">{fileSize}</span>
        </div>
      )}
      <div className="backup-card-footer">
        <span className={`backup-status-badge backup-status-badge--${status || 'critical'}`}>
          {(status || 'critical').charAt(0).toUpperCase() + (status || 'critical').slice(1)}
        </span>
      </div>
    </div>
  );

  if (isLoading) return (
    <div className="backup-health">
      <div className="backup-loading">Loading backup health...</div>
    </div>
  );

  if (error) return (
    <div className="backup-health">
      <div className="backup-error">{error}</div>
    </div>
  );

  return (
    <div className="backup-health">
      <div className="backup-card">
        <div className="backup-header-row">
          <div className="backup-header-left">
            <h3 className="backup-title">Backup Health</h3>
            {backupData?.fetchedAt && (
              <span className="backup-fetched-at">
                as of {formatDate(backupData.fetchedAt)}
              </span>
            )}
          </div>
          <div className="backup-header-right">
            {backupData && renderOverallBadge(backupData.overall)}
            <button className="backup-refresh-btn" onClick={fetchBackupHealth}>
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div className="backup-cards-row">
        {backupData && renderStatusCard({
          title:        'PostgreSQL Backup',
          lastRunLabel: 'Last backup',
          lastRun:      backupData.postgres?.lastRun,
          fileSize:     backupData.postgres?.fileSize,
          status:       backupData.postgres?.status,
        })}
        {backupData && renderStatusCard({
          title:        'Volumes Backup',
          lastRunLabel: 'Last backup',
          lastRun:      backupData.volumes?.lastRun,
          fileSize:     backupData.volumes?.fileSize,
          status:       backupData.volumes?.status,
        })}
        {backupData && renderStatusCard({
          title:        'IDrive Sync',
          lastRunLabel: 'Last sync',
          lastRun:      backupData.idrive?.lastSync,
          fileSize:     null,
          status:       backupData.idrive?.status,
        })}
      </div>
    </div>
  );
}

export default BackupHealth;
